import Purl from "../helpers/purlMapping";
import { BaseService } from "./base.service";
export class PurlService extends BaseService {
  static async getPurl(purlId, cms) {
    try {
      const response = await this.request().get(
        purlId === "purlId not included"
          ? process.env.VUE_APP_API_GET_PURL_PATH
          : `${process.env.VUE_APP_API_GET_PURL_PATH}/?purl=${purlId}`
      );
      const isGeneric = response?.data?.site?.rep?.email === "admin@";
      const hasPurlData = !!response?.data?.site;
      if (!hasPurlData) throw new Error("Purl not found.");
      return {
        purl: new Purl(response?.data?.site, cms),
        isGeneric,
      };
    } catch (e) {
      console.log("e", e.message);
      throw new Error(e.message);
    }
  }
}
